export default __webpack_public_path__ + "static/media/figma.22a83a4b.png";